import { Match } from '@libs/src/models/match.interfaces';
import { MatchmakingProgramPhase } from '@libs/src/models/program.model';
import { SurveyResponseAggregateResults } from '@main-client/src/app/program-survey-result-drawer/program-survey-result-drawer';

import flatMap from 'lodash-es/flatMap';
import sum from 'lodash-es/sum';

const scores = {
  scoreForActiveMatch: 1,
  scoreForNoSurveyResponse: 0,
  scoreForNotSeenMatch: 0,
  scoreForSeenMatch: 0.5,
  scoreForSurveyResponse: 1,
};

export function getMatchScore(
  match: Match,
  surveyResponses: SurveyResponseAggregateResults,
  matchmakingPhase: MatchmakingProgramPhase,
) {
  const numSurveysSent = surveyResponses?.surveys?.length || 0;
  const numCompletedPhases =
    numSurveysSent + (matchmakingPhase.phase_completed ? 1 : 0);
  const score =
    calculateScoreForMatchStatus(match.accounts[0]?.status) +
    calculateScoreForMatchStatus(match.accounts[1]?.status) +
    calculateScoreForMatchSurveyResponses(match, surveyResponses);
  return Math.round((score / (2 * numCompletedPhases)) * 100);
}

function calculateScoreForMatchStatus(status: string) {
  return 'seen' === status
    ? scores.scoreForSeenMatch
    : 'active' === status
    ? scores.scoreForActiveMatch
    : scores.scoreForNotSeenMatch;
}

function calculateScoreForMatchSurveyResponses(
  match: Match,
  surveyResponses: SurveyResponseAggregateResults,
) {
  if (!surveyResponses?.surveys) {
    return 0;
  }
  return sum(
    flatMap(surveyResponses?.surveys, (survey) =>
      survey.surveyResponses?.map(({ account }) =>
        account._id === match.accounts[0]?.document?._id ||
        account._id === match.accounts[1]?.document?._id
          ? scores.scoreForSurveyResponse
          : scores.scoreForNoSurveyResponse,
      ),
    ),
  );
}
